import {
  // fetchZoneDetails,
  // fetchFinancialYears,
  fetchRevenueTrendDetails,
  fetchDashboardSummaryWithoutFilter,
  // fetchWorkOrderByCategory,
  // fetchWorkOrderByStatus,
  fetchFilter,
  fetchTotalGrant,
  fetchContractorDetails,
  fetchSupplierDetails,
  fetchOpeningBalanceDetails,
  fetchExpenditureDetails,
  fetchPurchaseOrderDetails,
  fetchWorkOrderDetails,
  fetchExpenditureFundDetails,
  fetchWorkOrderFundDetails,
  fetchPurchaseOrderFundDetails,
  fetchReceiptsDetails,
  receiptsOrderDetails,
  departmentReceiptDetails,
  fetchDepartmentReceiptDetails,
  fetchSchemeDetailGrant,
  schemeDetailGrant
} from "egov-ui-kit/redux/app/actions";
import { getTenantId, getLocale, localStorageGet } from "egov-ui-kit/utils/localStorageUtils";
import React, { useState, useEffect, useRef } from "react";
import { connect } from "react-redux";
import "./index.css";
import DashboardCard from "../Home/DashboardCard";
import DashboardFilters from "../Home/DashboardFilters";
import BarCharts from "../Home/BarCharts";
import PieChart from "../Home/PieChart";
import { defaultFilters } from "./components/mockData";
import WorkOrderByCategory from "../Home/WorkOrderByCategory";
import WorkOrderByStatus from "../Home/WorkOrderByStatus";
import { showLoader, showTable } from "egov-ui-kit/redux/app/actions";
import Loader from "./components/Loader";
import TotalReceipts from "../Home/TotalReceipts";
import TotalExpenditureTable from "../Home/TotalExpenditureTable";
import WorkOrderTable from "../Home/WorkOrderTable";
import OpeningBalanceTable from "../Home/OpeningBalanceTable";
import GrantAmountTable from "../Home/GrantAmountTable";
import SupplierTabls from "../Home/SupplierTabls";
import ContractorTable from "../Home/ContractorTable";
import PurchaseOrderTable from "../Home/PurchaseOrderTable";

const Inbox = (props) => {
  const {
    // fetchZoneDetails,
    zoneDetails,
    financialYears,
    // fetchFinancialYears,
    revenueTrend,
    fetchRevenueTrendDetails,
    fetchDashboardSummaryWithoutFilter,
    receiptDetails,
    filterApi,
    // fetchWorkOrderByCategory,
    // workOrderByCategory,
    // fetchWorkOrderByStatus,
    // workOrderByStatus,
    fetchTotalGrant,
    fetchContractorDetails,
    supplierDetails,
    totalGrant,
    contractorDetails,
    showLoader,
    fetchFilter,
    showTable,
    Loadingloader,
    LoadingTable,
    fetchSupplierDetails,
    fetchOpeningBalanceDetails,
    openingBalanceDetails,
    expenditureDetails,
    fetchExpenditureDetails,
    fetchPurchaseOrderDetails,
    purchaseOrderDetails,
    fetchExpenditureFundDetails,
    expenditureFundDetails,
    fetchWorkOrderDetails,
    workOrderDetails,
    workOrderFundDetails,
    fetchWorkOrderFundDetails,
    fetchPurchaseOrderFundDetails,
    purchaseOrderFundDetails,
    fetchReceiptsDetails,
    receiptsOrderDetails,
    fetchDepartmentReceiptDetails,
    departmentReceiptDetails,
    fetchSchemeDetailGrant,
    schemeDetailGrant
  } = props;

  const [applyTrigger, setApplyTrigger] = useState(false);
  const tenantId = getTenantId();
  const [selectedCard, setSelectedCard] = useState(null);
  const [showValidationPopup, setShowValidationPopup] = useState(false);
  const zoneDetailRef = useRef(null);
  const [hideReceiptDetails, setHideReceiptDetails] = useState(false);
  const [cardClickCount, setCardClickCount] = useState(0);
  const [activeCard, setActiveCard] = useState(null);
  const [filters, setFilters] = useState({
    financialYear: "",
    tenantId: tenantId || "",
    ulbType: "",
    fromDate: "",
    toDate: "",
    ulbName: "",
    locale: getLocale() || "en_IN",
  });

  const formatDate = (date) => {
    if (!date) return "";

    const [year, month, day] = date.split("-");
    return `${day}-${month}-${year}`;
  };

  useEffect(() => {
    // fetchFinancialYears();
    fetchRevenueTrendDetails(filters);
    if (!(filters.financialYear && filters.ulbType)) {
      fetchDashboardSummaryWithoutFilter(filters);
    }

    // fetchWorkOrderByCategory(filters);
    // fetchWorkOrderByStatus(filters);
    // fetchZoneDetails(filters);
  }, [applyTrigger]);

  useEffect(() => {
    if (selectedCard && zoneDetailRef.current) {
      const timer = setTimeout(() => {
        const y = zoneDetailRef.current.getBoundingClientRect().top + window.pageYOffset - 80; // 80px top gap

        window.scrollTo({
          top: y,
          behavior: "smooth",
        });
      }, 100);

      return () => clearTimeout(timer);
    }
  }, [selectedCard]);

  const handleApplyFilters = () => {
    setSelectedCard(null);
    setActiveCard(null);
    const updatedFilters = {
      ...filters,
      fromDate: formatDate(filters.fromDate),
      toDate: formatDate(filters.toDate),
      locale: getLocale() || "en_IN",
    };

    setFilters(updatedFilters);

    showLoader(true);
    setTimeout(() => {
      showLoader(false);
    }, 1000);

    if (updatedFilters.financialYear && updatedFilters.ulbType) {
      fetchFilter(updatedFilters);
      setHideReceiptDetails(true);
    } else {
      setHideReceiptDetails(false);
    }

    setApplyTrigger((prev) => !prev);
  };

  const handleClick = (card) => {
    if (!filters.financialYear || !filters.ulbType) {
      setShowValidationPopup(true);
      return;
    }
    showLoader(true);

    // API calls should only fire when tenant-id is "hp"
    // if (localStorageGet("tenant-id") === "hp") {

    if (card.id === "noOfContractor") {
      fetchContractorDetails(filters);
    }

    if (card.id === "noOfSupplier") {
      fetchSupplierDetails(filters);
    }

    if (card.id === "openingBalance") {
      fetchOpeningBalanceDetails(filters);
    }

    if (card.id === "grantAmount") {
      fetchTotalGrant(filters);
    }

    if (card.id === "totalExpenditure") {
      fetchExpenditureDetails(filters);
    }

    if (card.id === "purchaseOrder") {
      fetchPurchaseOrderDetails(filters);
    }

    if (card.id === "workOrder") {
      fetchWorkOrderDetails(filters);
    }

    if (card.id === "totalReceipts") {
      fetchReceiptsDetails(filters);
    }
    // }
    //   else{
    //  showLoader(false);
    //   }

    setSelectedCard(card.id);
    setActiveCard(card.id);
    setCardClickCount((prev) => prev + 1);
    showTable(true);

    setTimeout(() => {
      showLoader(false);
    }, 500);
  };
  console.log("purchaseOrderDetails", purchaseOrderDetails);

  const closeValidationPopup = () => {
    setShowValidationPopup(false);
  };

  const handleResetFilters = () => {
    setSelectedCard(null);
    setActiveCard(null);
    setFilters({
      financialYear: "",
      tenantId: "",
      ulbType: "",
    });

    setHideReceiptDetails(false);
    setApplyTrigger((prev) => !prev);
  };

  // console.log("filterApi",filterApi)
  console.log("totalGrant", totalGrant);

  return (
    <div className="ulb-dulb-bg">
      {showValidationPopup && (
        <div className="validation-popup-overlay" onClick={closeValidationPopup}>
          <div className="validation-popup-box" onClick={(e) => e.stopPropagation()}>
            <p>Please select Financial Year and ULB Type</p>
            <button onClick={closeValidationPopup}>OK</button>
          </div>
        </div>
      )}

      <div className="vector-illustration"></div>
      <div className="headquarters-dulb">
        <div className="inner">
          <h3>Finance & Account Dashboard</h3>
          <span>Empowering transparent and efficient financial governance.</span>
        </div>

        {Loadingloader && <Loader />}

        <DashboardFilters
          filters={filters}
          onChange={setFilters}
          onApply={handleApplyFilters}
          onReset={handleResetFilters}
          receiptDetails={receiptDetails}
          setFilters={setFilters}
        />

        <div className="card-dulb-section">
          <div className="card">
            <DashboardCard
              filterApi={filterApi}
              {...(!hideReceiptDetails && { receiptDetails })}
              handleClick={handleClick}
              LoadingTable={LoadingTable}
              activeCard={activeCard}
            />
          </div>
        </div>

        <div id="zone-detail-table" ref={zoneDetailRef}>
          {selectedCard === "totalReceipts" && (
            <div>
              <TotalReceipts
                key={cardClickCount}
                ulbType={filters.ulbType}
                fromDate={filters.fromDate}
                toDate={filters.toDate}
                departmentReceiptDetails={departmentReceiptDetails}
                fetchDepartmentReceiptDetails={fetchDepartmentReceiptDetails}
                receiptsOrderDetails={receiptsOrderDetails}
              />
            </div>
          )}
          {selectedCard === "totalExpenditure" && (
            <div>
              <TotalExpenditureTable
                expenditureFundDetails={expenditureFundDetails}
                fetchExpenditureFundDetails={fetchExpenditureFundDetails}
                ulbType={filters.ulbType}
                fromDate={filters.fromDate}
                toDate={filters.toDate}
                key={cardClickCount}
                expenditureDetails={expenditureDetails}
              />
            </div>
          )}
          {selectedCard === "workOrder" && (
            <div>
              <WorkOrderTable
                ulbType={filters.ulbType}
                fromDate={filters.fromDate}
                toDate={filters.toDate}
                workOrderFundDetails={workOrderFundDetails}
                fetchWorkOrderFundDetails={fetchWorkOrderFundDetails}
                key={cardClickCount}
                workOrderDetails={workOrderDetails}
              />
            </div>
          )}

          {selectedCard === "openingBalance" && (
            <div>
              <OpeningBalanceTable key={cardClickCount} openingBalanceDetails={openingBalanceDetails} />
            </div>
          )}
          {selectedCard === "grantAmount" && (
            <div>
              <GrantAmountTable 
               fetchSchemeDetailGrant={fetchSchemeDetailGrant}
                schemeDetailGrant={schemeDetailGrant}
                ulbType={filters.ulbType}
                fromDate={filters.fromDate}
                toDate={filters.toDate}
                key={cardClickCount} grantDetails={totalGrant} />
            </div>
          )}
          {selectedCard === "noOfSupplier" && (
            <div>
              <SupplierTabls key={cardClickCount} supplierDetails={supplierDetails} />
            </div>
          )}

          {selectedCard === "noOfContractor" && (
            <div>
              <ContractorTable key={cardClickCount} contractorDetails={contractorDetails} />
            </div>
          )}
          {selectedCard === "purchaseOrder" && (
            <div>
              <PurchaseOrderTable
                ulbType={filters.ulbType}
                fromDate={filters.fromDate}
                toDate={filters.toDate}
                purchaseOrderFundDetails={purchaseOrderFundDetails}
                fetchPurchaseOrderFundDetails={fetchPurchaseOrderFundDetails}
                key={cardClickCount}
                purchaseOrderDetails={purchaseOrderDetails}
              />
            </div>
          )}
        </div>
      </div>
      {localStorageGet("tenant-id") !== "up" ? (
        <div className="dashboard-charts">
          <div className="chart-box">
            <div className="chart-inner">
              <BarCharts revenueTrend={revenueTrend} />
              <PieChart revenueTrend={revenueTrend} />
            </div>
          </div>
        </div>
      ) : (
        ""
      )}

      {/* <div className="dashboard-charts">
        <WorkOrderByCategory workOrderByCategory={workOrderByCategory} />
      </div> */}

      {/* <div className="dashboard-charts work-order-stauts">
        <WorkOrderByStatus workOrderByStatus={workOrderByStatus} />
        <WorkOrderByStatus workOrderByStatus={workOrderByStatus} />
      </div> */}
    </div>
  );
};

const mapStateToProps = (state) => {
  const { app } = state;
  const {
    financialYears = [],
    revenueTrend = [],
    receiptDetails = {},
    workOrderByCategory = { categories: [] },
    workOrderByStatus = { statuses: [] },
    zoneDetails = [],
    Loadingloader = false,
    LoadingTable = false,
    totalGrant = {},
    filterApi = {},
    contractorDetails = {},
    supplierDetails = {},
    openingBalanceDetails = {},
    expenditureDetails = {},
    purchaseOrderDetails = {},
    expenditureFundDetails = {},
    workOrderDetails = {},
    workOrderFundDetails = {},
    purchaseOrderFundDetails = {},
    receiptsOrderDetails = {},
    departmentReceiptDetails = {},
    schemeDetailGrant = {},
  } = app;
  return {
    LoadingTable,
    totalGrant,
    supplierDetails,
    openingBalanceDetails,
    contractorDetails,
    Loadingloader,
    financialYears,
    revenueTrend,
    receiptDetails,
    workOrderByCategory,
    workOrderByStatus,
    zoneDetails,
    expenditureDetails,
    filterApi,
    purchaseOrderDetails,
    expenditureFundDetails,
    workOrderDetails,
    workOrderFundDetails,
    purchaseOrderFundDetails,
    receiptsOrderDetails,
    departmentReceiptDetails,
    schemeDetailGrant,

  };
};

const mapDispatchToProps = (dispatch) => ({
  // fetchFinancialYears: () => dispatch(fetchFinancialYears()),
  fetchRevenueTrendDetails: (filters) => dispatch(fetchRevenueTrendDetails(filters)),
  fetchDashboardSummaryWithoutFilter: (filters) => dispatch(fetchDashboardSummaryWithoutFilter(filters)),
  fetchFilter: (filters) => dispatch(fetchFilter(filters)),
  fetchContractorDetails: (filters) => dispatch(fetchContractorDetails(filters)),
  fetchSupplierDetails: (filters) => dispatch(fetchSupplierDetails(filters)),
  // fetchWorkOrderByCategory: (filters) => dispatch(fetchWorkOrderByCategory(filters)),
  // fetchZoneDetails: (filters) => dispatch(fetchZoneDetails(filters)),
  // fetchWorkOrderByStatus: (filters) => dispatch(fetchWorkOrderByStatus(filters)),
  showLoader: (message) => dispatch(showLoader(message)),
  fetchTotalGrant: (filters) => dispatch(fetchTotalGrant(filters)),
  showTable: (message) => dispatch(showTable(message)),
  fetchOpeningBalanceDetails: (filters) => dispatch(fetchOpeningBalanceDetails(filters)),
  fetchExpenditureDetails: (filters) => dispatch(fetchExpenditureDetails(filters)),
  fetchPurchaseOrderDetails: (filters) => dispatch(fetchPurchaseOrderDetails(filters)),
  fetchExpenditureFundDetails: (filters) => dispatch(fetchExpenditureFundDetails(filters)),
  fetchWorkOrderFundDetails: (filters) => dispatch(fetchWorkOrderFundDetails(filters)),
  fetchPurchaseOrderFundDetails: (filters) => dispatch(fetchPurchaseOrderFundDetails(filters)),
  fetchReceiptsDetails: (filters) => dispatch(fetchReceiptsDetails(filters)),
  fetchDepartmentReceiptDetails: (filters) => dispatch(fetchDepartmentReceiptDetails(filters)),
  fetchWorkOrderDetails: (filters) => dispatch(fetchWorkOrderDetails(filters)),
  fetchSchemeDetailGrant: (filters) => dispatch(fetchSchemeDetailGrant(filters)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Inbox);



// WEBPACK FOOTER //
// src/modules/employee/Inbox/index.js